<template>
  <div class="menu-units-select">
    <v-expansion-panel v-model="showList">
      <v-expansion-panel-content expand-icon="enterprise--color bexsicon-down">
        <div slot="header" class="enterprise--color">
          {{ selectProduct }}
        </div>
        <div
          class="menu-units-select__list"
          v-for="(unitObj, i) in units"
          :key="i"
          :style="{
            fontWeight:
              unitObj.unit.id === selectedUnit.unit.id ? '500' : '400',
            backgroundColor:
              unitObj.unit.id === selectedUnit.unit.id
                ? '#f8f5f5'
                : 'transparent'
          }"
          @click="selectUnit(unitObj)"
        >
          <div class="menu-units-select__list__item">
            <p>{{ unitObj.product.title }}</p>
            <p v-if="unitObj.block.title">
              {{ unitObj.block.title }} - Unidade {{ unitObj.unitCodeClean }}
            </p>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>
<script>
import bus from '../../utils/bus';
import { UNIT } from '../../utils/constants';
export default {
  name: 'menu-units-select',
  computed: {
    config() {
      return this.$store.getters[CONFIG.GET];
    },
    selectProduct() {
      return this.$store.getters[UNIT.GET_IS_SYNDIC]
        ? 'Selecione seu empreendimento'
        : 'Selecione sua unidade';
    }
  },
  data() {
    return {
      showList: null
    };
  },
  methods: {
    selectUnit(unitObj) {
      this.$store.dispatch(UNIT.SELECT, unitObj);
      this.showList = this.showList === null ? 0 : null;
    }
  }
};
</script>
<style lang="scss">
@import '../../assets/scss/breakpoint';

.menu-units-select {
  &__list {
    padding: 0 30px;

    &__item {
      margin: 10px 0;
      padding: 5px 0 5px 10px;
      position: relative;
      font-size: 13px;

      @include breakpoint(mobile) {
        margin: 10px 0 0 15%;
        font-size: 0.9em;
      }

      &::before {
        content: '•';
        position: absolute;
        top: 5px;
        left: 0;
        color: var(--brand-color);
        font-weight: var(--font-weight);
      }

      p {
        margin: 0;
      }
    }
  }
  &__list__item {
    cursor: pointer;
    &:hover {
      font-weight: 500;
      text-shadow: 0px 0px 1px #00000077;
    }
  }

  .v-expansion-panel {
    box-shadow: none !important;
    margin: 0;

    @include breakpoint(desktop) {
      min-width: 225px;
    }
  }

  .v-expansion-panel__header {
    div {
      font-size: 14.4px;
    }
    @include breakpoint(desktop) {
      font-size: 13px;
      padding: 10px 18px;
    }

    @include breakpoint(mobile) {
      padding: 5px 18%;
    }

    div.v-expansion-panel__header__icon > i {
      font-size: 1.25em !important;
      @include breakpoint(mobile) {
        font-size: 1.1em !important;
      }
    }
  }

  .v-expansion-panel__body {
    height: auto;
    overflow-y: overlay;
  }

  .v-expansion-panel__container--active > .v-expansion-panel__header {
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/unitsSelect/MenuUnitsSelect.vue